import React, { FC } from "react";
import s from "./ExtraActionsMenu.module.scss";

export interface ExtraActionsItemProps {
  icon: React.ReactNode;
  label: string;
  type: "create" | "update" | "delete";
  onClick: () => void;
}

export interface ExtraActionsProps {
  props?: React.HTMLAttributes<HTMLDivElement>;
  content: ExtraActionsItemProps[];
}

export const ExtraActionsMenu: FC<ExtraActionsProps> = ({ content, props }) => {
  return (
    <div {...props} className={`${s.btn} ${props?.className ?? ""}`}>
      {content.map((item, index) => (
        <button
          key={index}
          className={`${s.item} ${s[item.type]}`}
          onClick={item.onClick}
        >
          <span className={s.icon}>{item.icon}</span>
          <span className={s.label}>{item.label}</span>
        </button>
      ))}
    </div>
  );
};
